<template>
  <v-layout column justify-space-between>
    <v-slide-y-transition group tag="div" class="loan-container">
      <div v-if="ready && item" key="content" class="content">
        <div class="px-4">
          <CompareLoansItem :item="item" :aciton="false" />
        </div>

        <ul class="mt-6 color--nice-grey font-size--14">
          <li>
            본 대출은 펀다에이아이가 {{ item.loan.lender.name }}의 대출을 중개하는 상품이며, 대출금리와
            대출한도는 신청자 정보를 기반으로 펀다에이아이가 예상 산출한 수치일 뿐 실제 대출신청 과정에서
            변경되거나, 대출승인이 거절될 수 있습니다.
          </li>
        </ul>
      </div>
    </v-slide-y-transition>

    <section class="px-3 pt-8 pb-7">
      <ApiButton
        color="primary"
        :classes="['font--m-3']"
        buttonText="신청하기"
        loadingText="신청중 입니다."
        :callFn="request"
      />
    </section>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {
    CompareLoansItem: () => import('@/components/compare-loans/CompareLoansItem.vue'),
    ApiButton: () => import('@/components/loans-request/ApiButton.vue'),
  },

  data() {
    return {
      ready: false,
      item: null,
    }
  },

  async created() {
    this.item = await this.getLoanOfferByUuid(this.$route.params.uuid)
  },

  mounted() {
    this.ready = true
  },

  methods: {
    ...mapActions('loanMarketplace', ['getLoanOfferByUuid', 'applyLoanOffer']),

    async request() {
      await this.applyLoanOffer(this.item.uuid)

      await this.$router.push({
        name: 'compare-loans/detail/complete',
        params: { uuid: this.item.uuid },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.v-list-item {
  padding-left: 0px !important;
  padding-right: 0px !important;

  &::after {
    display: none;
  }
}

li::marker {
  content: '※ ';
}
</style>
